export const MAP_ACTION = {
  SET: "set",
  DEL: "delete",
  HAS: "has",
  CLEAR: "clear",
};

export const PERMISSION_ROLE = {
  MENU: "MENU",
  SITE: "SITE",
};

// 资讯中心 tab对应的code
export const NEWS_TAB_CODE = [
  { label: "公司动态", value: "gsdt" },
  { label: "行业资讯", value: "hyzx" },
];

// 全局搜索类型选项
export const SEARCH_TYPE_OPTIONS = [
  { label: "全部", value: "all" },
  { label: "竞价", value: "jj" },
  { label: "拍卖", value: "pm" },
  { label: "招商项目", value: "zs" },
  { label: "资讯中心", value: "news" },
  { label: "帮助中心", value: "bzzx" },
];

// banner图配置
export const BANNER_CONFIG = {
  qyzcList: require("@/assets/images/qyzc/list-banner.jpg"),
  qyzcDetail: require("@/assets/images/qyzc/detail-banner.jpg"),
  gwczl: require("@/assets/images/gwczl/banner.jpg"),
  nbtp: require("@/assets/images/nbtp/banner.jpg"),
};

// 公告tab
export const NOTICE_TABS = [
  { label: "中止公告", value: "ZZGG" },
  { label: "终结公告", value: "ZJGG" },
  { label: "变更公告", value: "BGGG" },
  { label: "成交公告", value: "CJGG" },
  { label: "还原公告", value: "HYGG" },
  { label: "重新挂牌公告", value: "CXGPGG" },
];

// 公共标题配置
export const COMMON_TITLE_CONFIG = {
  jj: {
    title: "竞价项目",
    en: "LISTED PROJECT",
    tabList: [{ label: "全部", value: "" }],
    moreUrl: "/project/list/jj",
  },
  pm: {
    title: "拍卖项目",
    en: "LISTED PROJECT",
    tabList: [{ label: "全部", value: "" }],
    moreUrl: "/project/list/pm",
  },
  zs: {
    title: "招商项目",
    en: "INVESTMENT ATTRACTION PROJECT",
    tabList: [{ label: "全部", value: "" }],
    moreUrl: "/project/list/zs",
  },
  nb: {
    title: "信息披露中",
    en: "IN THE PROCESS OF INFORMATION DISCLOSURE",
    moreUrl: "/project/list/nb",
  },
  cj: {
    title: "成交项目",
    en: "CONCLUDE A TRANSACTION PROJECT",
    moreUrl: "/project/list/cj",
  },
  gsgg: {
    title: "公示公告",
    en: "ANNOUNCEMENT AND PUBLICITY",
    tabList: [{ label: "全部", value: "" }, ...NOTICE_TABS],
    moreUrl: "/project/list/gsgg",
  },
  yqlj: {
    title: "友情链接",
    en: "FRIENDLY LINKS",
    tabList: [
      { label: "合作单位", value: "hzdw" },
      { label: "相关单位", value: "xgdw" },
      { label: "中国中化下属企业", value: "xsqy" },
    ],
  },
};

// 项目状态
export const PROJECT_CONFIG = {
  0: {
    label: "已流标",
    subLabel: "已流标",
    color: "gray",
    html: "已经<br>流标",
  },
  1: {
    label: "竞价暂停",
    subLabel: "竞价暂停",
    color: "gray",
    html: "竞价<br>暂停",
  },
  2: {
    label: "已重新挂牌",
    subLabel: "已重新挂牌",
    color: "gray",
    html: "已重新<br>挂牌",
  },
  3: {
    label: "项目中止",
    subLabel: "项目中止",
    color: "gray",
    html: "项目<br>中止",
  },
  4: {
    label: "项目终结",
    subLabel: "项目终结",
    color: "gray",
    html: "项目<br>终结",
  },
  5: {
    label: "已成交",
    zsLabel: "已完成",
    subLabel: "已成交",
    color: "green",
    html: "已经<br>成交",
  },
  6: {
    label: "竞价截止",
    subLabel: "竞价已结束",
    color: "gray",
    html: "竞价<br>截止",
  },
  7: {
    label: "报名截止",
    zsLabel: "已结束",
    subLabel: "报名已截止",
    color: "gray",
    html: "报名<br>截止",
    zsHtml: "招商<br>结束",
  },
  8: {
    label: "未开始",
    zsLabel: "筹备中",
    subLabel: "未开始",
    color: "blue",
    html: "报名<br>未开始",
    zsHtml: "正在<br>筹备",
  },
  9: {
    label: "竞价中",
    subLabel: "竞价中",
    color: "red",
    html: "正在<br>竞价",
  },
  10: {
    label: "正在报名",
    zsLabel: "招商中",
    subLabel: "正在报名",
    color: "green",
    html: "正在<br>报名",
    zsHtml: "正在<br>招商",
  },
  11: { label: "正在报名，竞价中", color: "red", html: "报名<br>竞价" },
};

// 项目详情页信息展示区
export const PROJECT_INFO_CONFIG = {
  FC: [
    { label: "建筑面积", value: "mj", unit: "m²" },
    { label: "房产类型", value: "type" },
  ],
  FCZZ: [
    { label: "建筑面积", value: "mj", unit: "m²" },
    { label: "房产类型", value: "type" },
    { label: "租赁时间（使用期限）", value: "zlqx", unit: "年" },
  ],
  CL: [
    { label: "里程（里程表公里数）", value: "gls", unit: "公里" },
    { label: "注册日期", value: "zcrq" },
  ],
  JX: [{ label: "存放地", value: "area" }],
  WF: [
    { label: "废物类别", value: "type" },
    { label: "废物代码", value: "code" },
    { label: "存放地", value: "address" },
  ],
  GF: [
    { label: "废物类别", value: "type" },
    { label: "废物代码", value: "code" },
    { label: "存放地", value: "address" },
  ],
  TD: [
    { label: "面积", value: "mj", unit: "m²" },
    { label: "土地类型", value: "type" },
    { label: "使用期限", value: "zlqx", unit: "年" },
  ],
};
